var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.924,
    height: 69.223,
    viewBox: "0 0 97.924 69.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2341",
    "data-name": "Group 2341",
    transform: "translate(-218.326 -614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-coins",
    "data-name": "Icon awesome-coins",
    d: "M0,48.464V53.57c0,4.221,10.284,7.653,22.959,7.653s22.959-3.432,22.959-7.653V48.464c-4.938,3.48-13.966,5.106-22.959,5.106S4.938,51.944,0,48.464ZM38.264,15.306c12.675,0,22.959-3.432,22.959-7.653S50.939,0,38.264,0,15.306,3.432,15.306,7.653,25.589,15.306,38.264,15.306ZM0,35.921v6.17c0,4.221,10.284,7.653,22.959,7.653s22.959-3.432,22.959-7.653v-6.17c-4.938,4.066-13.978,6.17-22.959,6.17S4.938,39.986,0,35.921Zm49.744,1.315c6.852-1.327,11.479-3.791,11.479-6.624V25.506c-2.774,1.961-6.852,3.3-11.479,4.125Zm-26.785-18.1C10.284,19.132,0,23.413,0,28.7s10.284,9.566,22.959,9.566S45.917,33.983,45.917,28.7,35.634,19.132,22.959,19.132Zm26.223,6.732c7.175-1.291,12.041-3.826,12.041-6.732V14.026c-4.245,3-11.539,4.616-19.216,5C45.534,20.734,48.129,23.03,49.181,25.864Z",
    transform: "translate(218.326 622)",
    fill: "#12819c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-add-circle-outline",
    "data-name": "Icon ionic-ios-add-circle-outline",
    transform: "translate(283.625 610.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M24.363,16.875H19.125V11.637a1.125,1.125,0,0,0-2.25,0v5.238H11.637A1.077,1.077,0,0,0,10.512,18a1.089,1.089,0,0,0,1.125,1.125h5.238v5.238A1.09,1.09,0,0,0,18,25.488a1.119,1.119,0,0,0,1.125-1.125V19.125h5.238a1.125,1.125,0,0,0,0-2.25Z",
    fill: "#12819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M18,5.344A12.651,12.651,0,1,1,9.049,9.049,12.573,12.573,0,0,1,18,5.344m0-1.969A14.625,14.625,0,1,0,32.625,18,14.623,14.623,0,0,0,18,3.375Z",
    fill: "#12819c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.9554b431a61dd21367b72baf6e448bc0.svg";
export { ForwardRef as ReactComponent };